// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MapBuildingRightMenu__wrapper___tBQu2 {
    padding-right: 1.2rem;
    padding-left: 1.2rem;
}

.MapBuildingRightMenu__wrapper___tBQu2 > .MapBuildingRightMenu__rightMenuChoiceGroup___axHOK {
    display: flex;
    flex-grow: 1;
    margin-bottom: 1.6rem;
}

.MapBuildingRightMenu__sortTypeText___LrLto {
    margin-top: 0.8rem;
}

.MapBuildingRightMenu__selectItemContainer___vIEXu .MapBuildingRightMenu__selectItemMenuFields___lOory {
    width: 9rem;
    padding-right: 0.4rem;
    padding-left: 0.4rem;
}

.MapBuildingRightMenu__faultsInput___u7ABB {
    display: flex;
    flex-direction: column;
    padding: 0.8rem 1.2rem;
}

.MapBuildingRightMenu__firstField___jIH96 {
    display: flex;
    justify-content: flex-end;
}

.MapBuildingRightMenu__menuFields___lo7F7 {
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
}

.MapBuildingRightMenu__rowMenuFields___zAQ61 {
    display: flex;
    gap: var(--space-xs);
    align-items: start;
}

.MapBuildingRightMenu__columnMenuFields___S4GCc {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.MapBuildingRightMenu__menuFieldsPadding___dcuGI {
    padding-bottom: 2rem;
}

.MapBuildingRightMenu__menuFields___lo7F7 .MapBuildingRightMenu__geometryMenuTextFields___Y13v2 {
    width: 19.6rem;
    padding-bottom: 0.8rem;
}

.MapBuildingRightMenu__menuFields___lo7F7 .MapBuildingRightMenu__geometryMenuGridFields___ECVcw {
    width: 9.6rem;
}

.MapBuildingRightMenu__geometryMenuGridFieldsMargin___C56Fd {
    margin-right: 0.4rem;
}

.MapBuildingRightMenu__algorithmMenuSelect___cEPj5,
.MapBuildingRightMenu__mapMenuSelect___a0zVf {
    width: 29.6rem;
}

.MapBuildingRightMenu__algorithmMenuSelectMargin___APoQ6 {
    margin-bottom: 1.6rem;
}

.MapBuildingRightMenu__algorithmMenuTextFields___eRlIt {
    padding-bottom: 1.2rem;
}

.MapBuildingRightMenu__menuFields___lo7F7 .MapBuildingRightMenu__algorithmMenuTextFields___eRlIt {
    width: 18.4rem;
}

.MapBuildingRightMenu__algorithmMenuGridFields___cvwd2 {
    width: 9rem;
}

.MapBuildingRightMenu__algorithmMenuGridFields___cvwd2:first-of-type {
    margin-right: 0.4rem;
}

.MapBuildingRightMenu__selectItem___wzJQ1 {
    padding: 0.8rem 1.2rem;
}

.MapBuildingRightMenu__selectItem___wzJQ1:hover {
    background-color: var(--color-control-bg-ghost);
}

.MapBuildingRightMenu__deleteButton___qooKt {
    color: var(--color-control-typo-placeholder);
}

.MapBuildingRightMenu__selectItem___wzJQ1 .MapBuildingRightMenu__deleteButton___qooKt {
    display: none;
}

.MapBuildingRightMenu__selectItem___wzJQ1:hover .MapBuildingRightMenu__deleteButton___qooKt {
    display: block;
}

.MapBuildingRightMenu__treeInput___y1kHR {
    width: 18.2rem;
}

.MapBuildingRightMenu__firstField___jIH96 .MapBuildingRightMenu__algorithmMenuTextFields___eRlIt {
    width: 18.4rem;
}

.MapBuildingRightMenu__header___MZFm2 {
    margin: 0.8rem 1.2rem 0;
}

.MapBuildingRightMenu__typeText___PqXPH {
    padding-top: 0.4rem;
    padding-right: 1.2rem;
}

.MapBuildingRightMenu__text___uomfp {
    padding-right: 1.2rem;
}

.MapBuildingRightMenu__textAfterSpace___EAbWw {
    padding: var(--space-xl) 0 var(--space-xs) 0;
}

.MapBuildingRightMenu__angleWrapper___eO_2x {
    padding-top: 0.8rem;
}

.MapBuildingRightMenu__selectItemContainer___vIEXu {
    display: flex;
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
}

.MapBuildingRightMenu__algorithmMenuContainer___pBGSs {
    padding: 0.8rem 1.2rem;
}

.MapBuildingRightMenu__variogrammHeader___nQv33 {
    margin-bottom: 1.2rem;
}

.MapBuildingRightMenu__variogrammIntro___mp1Gb {
    margin-right: 0.4rem;
}

.MapBuildingRightMenu__textPadding___tLA7u {
    padding-right: 1.2rem;
}

.MapBuildingRightMenu__mapMenuTextWrapper___cfmVr {
    padding: 1.2rem 0.8rem;
}

.MapBuildingRightMenu__mapMenuSelect___a0zVf {
    padding-bottom: 0.8rem;
}

.MapBuildingRightMenu__faultsText___vUr18 {
    padding-bottom: 0.8rem;
}

.MapBuildingRightMenu__thirdTextWrapper___xvfS1 {
    padding-bottom: 2rem;
}

.MapBuildingRightMenu__headerMargin___ZsF0H {
    margin-bottom: 1.6rem;
}

.MapBuildingRightMenu__errorText___sgtcK {
    display: flex;
    align-items: baseline;
    justify-content: flex-end;

    padding-top: var(--space-xl);

    color: var(--color-bg-alert);
    text-align: right;
}

.MapBuildingRightMenu__validatedTextFields___zdZp_ {
    width: 14.4rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/modules/Modals/MapBuilding/MapBuildingRightMenu/MapBuildingRightMenu.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,yBAAyB;;IAEzB,4BAA4B;;IAE5B,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".wrapper {\n    padding-right: 1.2rem;\n    padding-left: 1.2rem;\n}\n\n.wrapper > .rightMenuChoiceGroup {\n    display: flex;\n    flex-grow: 1;\n    margin-bottom: 1.6rem;\n}\n\n.sortTypeText {\n    margin-top: 0.8rem;\n}\n\n.selectItemContainer .selectItemMenuFields {\n    width: 9rem;\n    padding-right: 0.4rem;\n    padding-left: 0.4rem;\n}\n\n.faultsInput {\n    display: flex;\n    flex-direction: column;\n    padding: 0.8rem 1.2rem;\n}\n\n.firstField {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.menuFields {\n    display: flex;\n    align-items: baseline;\n    justify-content: flex-end;\n}\n\n.rowMenuFields {\n    display: flex;\n    gap: var(--space-xs);\n    align-items: start;\n}\n\n.columnMenuFields {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n}\n\n.menuFieldsPadding {\n    padding-bottom: 2rem;\n}\n\n.menuFields .geometryMenuTextFields {\n    width: 19.6rem;\n    padding-bottom: 0.8rem;\n}\n\n.menuFields .geometryMenuGridFields {\n    width: 9.6rem;\n}\n\n.geometryMenuGridFieldsMargin {\n    margin-right: 0.4rem;\n}\n\n.algorithmMenuSelect,\n.mapMenuSelect {\n    width: 29.6rem;\n}\n\n.algorithmMenuSelectMargin {\n    margin-bottom: 1.6rem;\n}\n\n.algorithmMenuTextFields {\n    padding-bottom: 1.2rem;\n}\n\n.menuFields .algorithmMenuTextFields {\n    width: 18.4rem;\n}\n\n.algorithmMenuGridFields {\n    width: 9rem;\n}\n\n.algorithmMenuGridFields:first-of-type {\n    margin-right: 0.4rem;\n}\n\n.selectItem {\n    padding: 0.8rem 1.2rem;\n}\n\n.selectItem:hover {\n    background-color: var(--color-control-bg-ghost);\n}\n\n.deleteButton {\n    color: var(--color-control-typo-placeholder);\n}\n\n.selectItem .deleteButton {\n    display: none;\n}\n\n.selectItem:hover .deleteButton {\n    display: block;\n}\n\n.treeInput {\n    width: 18.2rem;\n}\n\n.firstField .algorithmMenuTextFields {\n    width: 18.4rem;\n}\n\n.header {\n    margin: 0.8rem 1.2rem 0;\n}\n\n.typeText {\n    padding-top: 0.4rem;\n    padding-right: 1.2rem;\n}\n\n.text {\n    padding-right: 1.2rem;\n}\n\n.textAfterSpace {\n    padding: var(--space-xl) 0 var(--space-xs) 0;\n}\n\n.angleWrapper {\n    padding-top: 0.8rem;\n}\n\n.selectItemContainer {\n    display: flex;\n    padding-top: 0.8rem;\n    padding-bottom: 0.8rem;\n}\n\n.algorithmMenuContainer {\n    padding: 0.8rem 1.2rem;\n}\n\n.variogrammHeader {\n    margin-bottom: 1.2rem;\n}\n\n.variogrammIntro {\n    margin-right: 0.4rem;\n}\n\n.textPadding {\n    padding-right: 1.2rem;\n}\n\n.mapMenuTextWrapper {\n    padding: 1.2rem 0.8rem;\n}\n\n.mapMenuSelect {\n    padding-bottom: 0.8rem;\n}\n\n.faultsText {\n    padding-bottom: 0.8rem;\n}\n\n.thirdTextWrapper {\n    padding-bottom: 2rem;\n}\n\n.headerMargin {\n    margin-bottom: 1.6rem;\n}\n\n.errorText {\n    display: flex;\n    align-items: baseline;\n    justify-content: flex-end;\n\n    padding-top: var(--space-xl);\n\n    color: var(--color-bg-alert);\n    text-align: right;\n}\n\n.validatedTextFields {\n    width: 14.4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `MapBuildingRightMenu__wrapper___tBQu2`,
	"rightMenuChoiceGroup": `MapBuildingRightMenu__rightMenuChoiceGroup___axHOK`,
	"sortTypeText": `MapBuildingRightMenu__sortTypeText___LrLto`,
	"selectItemContainer": `MapBuildingRightMenu__selectItemContainer___vIEXu`,
	"selectItemMenuFields": `MapBuildingRightMenu__selectItemMenuFields___lOory`,
	"faultsInput": `MapBuildingRightMenu__faultsInput___u7ABB`,
	"firstField": `MapBuildingRightMenu__firstField___jIH96`,
	"menuFields": `MapBuildingRightMenu__menuFields___lo7F7`,
	"rowMenuFields": `MapBuildingRightMenu__rowMenuFields___zAQ61`,
	"columnMenuFields": `MapBuildingRightMenu__columnMenuFields___S4GCc`,
	"menuFieldsPadding": `MapBuildingRightMenu__menuFieldsPadding___dcuGI`,
	"geometryMenuTextFields": `MapBuildingRightMenu__geometryMenuTextFields___Y13v2`,
	"geometryMenuGridFields": `MapBuildingRightMenu__geometryMenuGridFields___ECVcw`,
	"geometryMenuGridFieldsMargin": `MapBuildingRightMenu__geometryMenuGridFieldsMargin___C56Fd`,
	"algorithmMenuSelect": `MapBuildingRightMenu__algorithmMenuSelect___cEPj5`,
	"mapMenuSelect": `MapBuildingRightMenu__mapMenuSelect___a0zVf`,
	"algorithmMenuSelectMargin": `MapBuildingRightMenu__algorithmMenuSelectMargin___APoQ6`,
	"algorithmMenuTextFields": `MapBuildingRightMenu__algorithmMenuTextFields___eRlIt`,
	"algorithmMenuGridFields": `MapBuildingRightMenu__algorithmMenuGridFields___cvwd2`,
	"selectItem": `MapBuildingRightMenu__selectItem___wzJQ1`,
	"deleteButton": `MapBuildingRightMenu__deleteButton___qooKt`,
	"treeInput": `MapBuildingRightMenu__treeInput___y1kHR`,
	"header": `MapBuildingRightMenu__header___MZFm2`,
	"typeText": `MapBuildingRightMenu__typeText___PqXPH`,
	"text": `MapBuildingRightMenu__text___uomfp`,
	"textAfterSpace": `MapBuildingRightMenu__textAfterSpace___EAbWw`,
	"angleWrapper": `MapBuildingRightMenu__angleWrapper___eO_2x`,
	"algorithmMenuContainer": `MapBuildingRightMenu__algorithmMenuContainer___pBGSs`,
	"variogrammHeader": `MapBuildingRightMenu__variogrammHeader___nQv33`,
	"variogrammIntro": `MapBuildingRightMenu__variogrammIntro___mp1Gb`,
	"textPadding": `MapBuildingRightMenu__textPadding___tLA7u`,
	"mapMenuTextWrapper": `MapBuildingRightMenu__mapMenuTextWrapper___cfmVr`,
	"faultsText": `MapBuildingRightMenu__faultsText___vUr18`,
	"thirdTextWrapper": `MapBuildingRightMenu__thirdTextWrapper___xvfS1`,
	"headerMargin": `MapBuildingRightMenu__headerMargin___ZsF0H`,
	"errorText": `MapBuildingRightMenu__errorText___sgtcK`,
	"validatedTextFields": `MapBuildingRightMenu__validatedTextFields___zdZp_`
};
export default ___CSS_LOADER_EXPORT___;
